import { useInfiniteQuery } from "@tanstack/react-query";
import { api, call, xClient } from "@/api/spec";
import { qk } from "@/api/queryKeys";
import type { TransactionType } from "@/api/types";

/** 계약 기본값(limit 기본 20·최대 50). */
const PAGE_SIZE = 20;

/** GET /api/me/bricks/transactions?type=&cursor=(1.17). 탭별 독립 캐시(qk.transactions(type)). */
export function useTransactions(type: TransactionType) {
  return useInfiniteQuery({
    queryKey: qk.transactions(type),
    queryFn: ({ pageParam }) =>
      call(api.GET("/me/bricks/transactions", { params: { header: xClient(), query: { type, limit: PAGE_SIZE, ...(pageParam ? { cursor: pageParam } : {}) } } })),
    initialPageParam: null as string | null,
    getNextPageParam: (last) => last.nextCursor,
  });
}
